import type { ParticipantDocument } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaCaretDown, FaHistory, FaPencilAlt, FaRegClone, FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { ParticipantDocumentCloneModal } from './ParticipantDocumentCloneModal';
import { ParticipantDocumentDeleteModal } from './ParticipantDocumentDeleteModal';
import { ParticipantDocumentEditModal } from './ParticipantDocumentEditModal';
import { ParticipantDocumentHistoryModal } from './ParticipantDocumentHistoryModal';
import { ParticipantDocumentPdfMenuItem } from './ParticipantDocumentPdfMenuItem';

interface Props extends ChakraV3.ButtonProps {
  participantDocument: ParticipantDocument;
}

export const ParticipantDocumentActionMenu = (props: Props) => {
  const { participantDocument, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.Menu.ItemGroup>
            <ChakraV3.Menu.ItemGroupLabel>PDFs</ChakraV3.Menu.ItemGroupLabel>
            <ParticipantDocumentPdfMenuItem participantDocument={participantDocument} />
          </ChakraV3.Menu.ItemGroup>
          <ChakraV3.Menu.ItemGroup>
            <ChakraV3.Menu.ItemGroupLabel>Document</ChakraV3.Menu.ItemGroupLabel>
            <ChakraV3.MenuItem
              onClick={() =>
                showModal(ParticipantDocumentHistoryModal, {
                  document: participantDocument,
                })
              }
              value='view-version-history'
            >
              <FaHistory />
              View version history
            </ChakraV3.MenuItem>
            <ChakraV3.MenuItem
              onClick={() =>
                showModal(ParticipantDocumentEditModal, {
                  document: participantDocument,
                })
              }
              value='edit'
            >
              <FaPencilAlt />
              Edit
            </ChakraV3.MenuItem>
            <ChakraV3.MenuItem
              onClick={() =>
                showModal(ParticipantDocumentCloneModal, {
                  participantId: participantDocument.participantId,
                  participantDocumentId: participantDocument.id,
                })
              }
              value='clone'
            >
              <FaRegClone />
              Clone
            </ChakraV3.MenuItem>
            <ChakraV3.MenuItem
              color='danger'
              value='delete'
              onClick={() =>
                showModal(ParticipantDocumentDeleteModal, {
                  participantId: participantDocument.participantId,
                  participantDocumentId: participantDocument.id,
                  participantDocumentName: participantDocument.name,
                })
              }
            >
              <FaRegTrashAlt />
              Delete
            </ChakraV3.MenuItem>
          </ChakraV3.Menu.ItemGroup>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='plain' size='sm' flexShrink={0} {...rest}>
          Actions
          <FaCaretDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
    </ChakraV3.Menu.Root>
  );
};
